import request from '../utils/request.js'


// 新增【请填写功能名称】
export function addForm(data) {
  return request({
    url: '/system/form',
    method: 'post',
    data: data
  })
}
